import { Trans } from 'react-i18next'
export default ({ viewMode, toggleViewMode, numberOfCards }) =>
  <div className="care-options-header careOptionMarginTop care-optionHeader">
    {numberOfCards > 2
      ?
      <a className="view-mode-toggle standby-info-card-view carousel-careOption"
        href='#'
        onClick={() => toggleViewMode()}
      >{viewMode === 'carousel' ? <Trans i18nKey="findcareoption.Careoptions.ListView">List View </Trans> : <Trans i18nKey="findcareoption.Careoptions.CarouselView">Carousel View</Trans>}</a>
      : null
    }

    {numberOfCards > 2
      ?
      <a className="view-mode-toggle standby-info-card-view-mobile"
        onClick={() => toggleViewMode()}
        href='#'
      >{viewMode === 'carousel' ? <Trans i18nKey="findcareoption.Careoptions.CarouselView">Carousel View </Trans> : <Trans i18nKey="findcareoption.Careoptions.ListView">List View</Trans>}</a>
      : null
    }

    {viewMode === 'carousel' ?
      <h1 className="standby-page-header-title"><Trans i18nKey="findcareoption.Careoptions.Care_title">Available Care Options</Trans></h1>
      : <h1 className="care-options-listView care-optionMobileView"><Trans i18nKey="findcareoption.Careoptions.Care_title">Available Care Options</Trans></h1>
    }  
</div>
